import _toLower from 'lodash/toLower';
import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  REINIT_AUTH,
  CHANGE_LOCALE,
  GET_ME,
  UPDATE_ME,
  CPM_DELETE_MY_PAYMENT_METHOD,
  POST_LOGOUT,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/user';
import { isAdmin } from '../../models/permission';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.me;
const me = (state = initialSettings, action) => {
  let key;
  let featuresOrPermissions;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      switch (action.target) {
        case 'updateMe':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // REINIT AUTH
    case REINIT_AUTH:
      return {
        ...state,
        error: null,
        loading: false,
        data: null,
      };
    // POST_LOGOUT
    case POST_LOGOUT:
      return {
        ...state,
        logout: true,
      };
    // CHANGE LOCALE
    case CHANGE_LOCALE:
      return {
        ...state,
        data: state.data ? {
          ...state.data,
          locale: action.locale,
        } : null,
      };
    // GET
    case GET_ME:
      return {
        ...state,
        error: null,
        loading: true,
        data: null,
        logout: false,
      };
    case `${GET_ME}_ERROR`:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case `${GET_ME}_SUCCESS`:
      featuresOrPermissions = action.useGraphQL ? _map(action.data.me.features, _toLower) : action.data.data.permissions;

      return {
        ...state,
        error: null,
        loading: false,
        data: action.useGraphQL ? deserialize(action.data.me) : deserialize(action.data.data),
        features: action.useGraphQL ? featuresOrPermissions : null,
        isAdmin: isAdmin(featuresOrPermissions, action.useGraphQL),
      };
    // UPDATE
    case UPDATE_ME:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${UPDATE_ME}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${UPDATE_ME}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // CPM_DELETE_MY_PAYMENT_METHOD
    case CPM_DELETE_MY_PAYMENT_METHOD:
      return {
        ...state,
        deleteMyPaymentMethod: {
          ...state.deleteMyPaymentMethod,
          error: null,
          deleted: false,
        },
      };
    case `${CPM_DELETE_MY_PAYMENT_METHOD}_ERROR`:
      return {
        ...state,
        deleteMyPaymentMethod: {
          ...state.deleteMyPaymentMethod,
          error: action.error,
          deleted: false,
        },
      };
    case `${CPM_DELETE_MY_PAYMENT_METHOD}_SUCCESS`:
      return {
        ...state,
        deleteMyPaymentMethod: {
          ...state.deleteMyPaymentMethod,
          error: null,
          deleted: true,
        },
      };
    default:
      return state;
  }
};

export default me;



// WEBPACK FOOTER //
// ./reducers/auth/me.js